import React, { useState } from 'react';

export const CalmEmpty = ({ palette, bodyFont, headingFont, c, onAddCharacter }) => {
  const [hover, setHover] = useState(false);
  return (
    <div style={{
      display: 'flex', alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
    }}>
      <div>
        <div style={{
          fontFamily: headingFont,
          fontSize: '1.05rem',
          fontWeight: 600,
          color: c.textPrimary,
          marginBottom: 4,
        }}>No character yet</div>
        <div style={{
          fontFamily: bodyFont,
          fontSize: '0.86rem',
          color: c.textMuted,
          maxWidth: 480,
          lineHeight: 1.45,
        }}>
          Bring one of your solo characters to this campaign, or create a new one.
        </div>
      </div>
      {onAddCharacter && (
        <button
          onClick={onAddCharacter}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            padding: '9px 16px',
            background: hover ? palette.light : palette.color,
            border: 'none',
            borderRadius: 6,
            color: c.textOnAccent,
            fontFamily: bodyFont,
            fontSize: '0.86rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background 150ms ease',
            whiteSpace: 'nowrap',
          }}
        >Add character</button>
      )}
    </div>
  );
};
